import _ from "lodash";
import useTranslate from "../../../../modules/local/useTranslate";
import {useOrgTypeLabels} from "../../../../modules/local/useOrgTypeLabels";
import React, {useMemo, useState} from "react";
import {NullAsDefault} from "../../../Shared";
import {useOrganizationGroupApi} from "./useOrganizationGroupApi";
import {showConfirmDialog, showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {createModalTitle} from "../../../../components/renderFunctions/createModalTitle";
import {getId} from "../../../../apis/model/base";
import {Modal} from "antd";
import {OrganizationGroupCreateForm, OrganizationGroupUpdateForm} from "../components/OrganizationGroupForm";
import {OrganizationActionTypes} from "../../../Workspace/Host/WorkspaceMembers";
import {
    OrganizationGroupAddMemberForm,
    OrganizationGroupCreateMemberForm,
    OrganizationGroupUpdateMemberForm
} from "../components/OrganizationGroupMemberForm";
import {BsEyeSlashFill} from "react-icons/bs";


export const useOrganizationGroupForm = ({
                                                  organization,
                                                  organizationGroup,
                                              }) => {
    const t = useTranslate()
    const orgLabels = useOrgTypeLabels(organization?.org_type)
    const [refreshToken, setRefreshToken] = useState()
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })
    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        onCancel()
        setRefreshToken(Date.now())
    }


    const {
        onCreate, creatingAsync,
        onUpdate, updatingAsync,
        onDelete, deletingAsync,
        addMember, addingMemberAsync,
        editMember, editingMemberAsync,
        removeMember, removingMemberAsync,
        setMemberActive, settingMemberActiveAsync
    } = useOrganizationGroupApi({
        notifyListeners: {
            onRefresh
        }
    })


    const handleAction = (action, params) => {
        switch (action) {
            case OrganizationActionTypes.DEPT_CREATE:
            case OrganizationActionTypes.DEPT_UPDATE:
            case OrganizationActionTypes.DEPT_ADD_MEMBER:
            case OrganizationActionTypes.DEPT_ADD_ORG_MEMBER:
            case OrganizationActionTypes.DEPT_EDIT_MEMBER:
                setAction({
                    type: action,
                    value: params,
                })
                break
            case OrganizationActionTypes.DEPT_DELETE:
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete this item',
                    message: 'are you sure you want to delete this',
                    onOk: () => {
                        onDelete({}, {id: params?.id})
                    },
                })
                break
            case OrganizationActionTypes.DEPT_DELETE_MEMBER:
                showConfirmDialog({
                    translate: t,
                    title: 'remove member',
                    message: 'are you sure you want to remove this member from the department',
                    onOk: () => {
                        removeMember({}, {id: params?.id})
                    },
                })
                break
            case OrganizationActionTypes.DEPT_MEMBER_SET_ACTIVE:
                showConfirmDialog({
                    icon: <BsEyeSlashFill className="anticon"/>,
                    translate: t,
                    title: !!!params?.active ? 'activate member' : 'deactivate member',
                    message: !!!params?.active
                        ? 'do you want to activate this member'
                        : 'do you want to deactivate this member',
                    onOk: () => {
                        setMemberActive({active: !!!params?.active ? 1 : 0}, {id: params?.id})
                    },
                })
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault

        switch (action?.type) {
            case OrganizationActionTypes.DEPT_CREATE:
                modal_params = {
                    title: createModalTitle(t('create') + ' ' + (_.get(orgLabels, 'department.default') || _.get(orgLabels, 'department.label') || t('group / ministry'))),
                    width: 600,
                }
                params = {
                    initialValues: {...(action?.value || {})},
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        onCreate(values, {id: organization?.id})
                    },
                }
                Component = OrganizationGroupCreateForm
                break
            case OrganizationActionTypes.DEPT_UPDATE:
                const group_id = getId(action?.value)
                modal_params = {
                    title: createModalTitle(t('edit') + ' ' + (_.get(orgLabels, 'department.default') || _.get(orgLabels, 'department.label') || t('group / ministry'))),
                    width: 600,
                }
                params = {
                    organizationGroup,
                    organization,
                    group_id,
                    initialValues: {...action?.value},
                    isSubmitting: updatingAsync.isLoading,
                    onSubmit: (values) => {
                        onUpdate(values, {id: group_id})
                    },
                }
                Component = OrganizationGroupUpdateForm
                break
            case OrganizationActionTypes.DEPT_ADD_MEMBER:
                modal_params = {
                    title: createModalTitle('add member'),
                    width: 600,
                }
                params = {
                    organizationGroup,
                    organization,
                    initialValues: {...(action?.value || {})},
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        addMember(values, {id: values?.group_id})
                    },
                }
                Component = OrganizationGroupCreateMemberForm
                break
            case OrganizationActionTypes.DEPT_ADD_ORG_MEMBER:
                modal_params = {
                    title: createModalTitle('add member'),
                    width: 600,
                }
                params = {
                    organizationGroup,
                    organization,
                    isSubmitting: creatingAsync.isLoading,
                    onSubmit: (values) => {
                        addMember(values, {id: values?.group_id})
                    },
                }
                Component = OrganizationGroupAddMemberForm
                break
            case OrganizationActionTypes.DEPT_EDIT_MEMBER:
                const id = getId(action?.value)
                modal_params = {
                    title: createModalTitle('edit member'),
                    width: 600,
                }
                params = {
                    organization,
                    organizationGroup,
                    initialValues: {...action?.value},
                    isSubmitting: updatingAsync.isLoading,
                    onSubmit: (values) => {
                        editMember(values, {id: id})
                    },
                }
                Component = OrganizationGroupUpdateMemberForm
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Component
                    {...{onCancel}}
                    {...params}
                    organization={organization}
                />
            </Modal>
        )
    }, [action, organization, creatingAsync.isLoading, updatingAsync.isLoading])

    return {
        modal,
        action,
        onCancel,
        handleAction,
        refreshToken,
    }
}